import { ExpeditionsQueueStatus } from "./status";

export const ExpeditionsQueue = {
  status: ExpeditionsQueueStatus
} as const;
